module.exports = __webpack_public_path__ + "static/media/carousel-06.aa8ebce8.jpg";